import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06490fc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sem set-margin--auto layout-mode--rows layout-height--auto set-justify-content--center set-align-items--center layout-gutters--large" }
const _hoisted_2 = {
  key: 1,
  style: {"max-width":"380px"},
  class: "sem is-sem layout-width--auto set-background-color--gray-100 set-box-shadow--largest set-border-radius--normal set-padding--largest"
}
const _hoisted_3 = { class: "sem is-prio--higher set-margin--none set-padding-bottom--largest set-font-weight--700 set-color--neutral-700" }
const _hoisted_4 = { class: "sem is-sem set-font-size--300 set-color--neutral-700" }
const _hoisted_5 = {
  class: "sem is-sem layout-mode--rows set-padding-bottom--largest",
  style: {"padding-top":"20px"}
}
const _hoisted_6 = {
  class: "sem is-sem set-font-size--200 set-letter-spacing--500 set-color--neutral-700",
  for: "email"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_pdr_icon = _resolveComponent("pdr-icon")!
  const _component_pdr_field = _resolveComponent("pdr-field")!
  const _component_one_ux_button = _resolveComponent("one-ux-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isInitializing)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          size: "40"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", {
            ref: "form",
            class: "sem is-sem set-padding-right--normal set-padding-left--normal set-padding-top--normal layout-width--auto set-padding-bottom--larger",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.language.welcome_to_stratsys), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.language.sign_in_to_your_account), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.language.email), 1),
              _createVNode(_component_pdr_field, {
                error: _ctx.error,
                class: "sem set-position--relative set-display--block"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_pdr_icon, {
                    class: "set-position--absolute set-margin-left--normal set-font-size--350 set-left--small set-width--x4",
                    style: {"top":"50%","transform":"translateY(-50%)"},
                    "fontawesome-regular": "user"
                  }),
                  _withDirectives(_createElementVNode("input", {
                    id: "email",
                    ref: "input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                    class: _normalizeClass(["sem is-sem layout-width--auto set-padding-left--largest", { 'is-busy': _ctx.isHandlingSubmit }]),
                    type: "email",
                    placeholder: "name.lastname@domain.com",
                    autofocus: "",
                    required: ""
                  }, null, 2), [
                    [_vModelText, _ctx.email]
                  ])
                ]),
                _: 1
              }, 8, ["error"])
            ]),
            _createVNode(_component_one_ux_button, {
              disabled: _ctx.isHandlingSubmit || !_ctx.isValidEmail,
              purpose: "main",
              text: _ctx.language.next,
              width: "max",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.form.requestSubmit()))
            }, null, 8, ["disabled", "text"])
          ], 544)
        ]))
  ]))
}